import React from 'react';
import { ServicePage } from './ServicePage';
import { getService } from '../data/services';
const service = getService('lead-scoring');
export function LeadScoringPage() {
  if (!service) return null;
  return <ServicePage service={service} data-id="element-240" data-mp="tpmk2eq31ijc" />;
}